/**
 * @generated SignedSource<<a1e6f8dcbc8631e0a30b9583cf8ea02e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureKey = "ADDITIONAL_LISTS" | "BIOMETRIC_LOCK" | "BUDGET" | "ESTATE_SEARCH" | "EXTENDED_ADDRESS_LOOKUP" | "FLOOD_MAP" | "HOME_FEED" | "HOME_OWNERSHIP" | "HOME_RECORDS" | "HOME_UPDATES" | "HOME_UPDATES_PUSH_ANNIVERSARY" | "HOME_UPDATES_PUSH_FLOOD" | "HOME_UPDATES_PUSH_HOME_VALUE" | "HOME_UPDATES_PUSH_PLANNING" | "HOME_UPDATES_PUSH_RATE_DECISION" | "HOME_UPDATES_PUSH_RENT_CHECK" | "HOME_UPDATES_PUSH_SOLD_NEAR_YOU" | "HOUSEHOLD_MONEY" | "JOURNEY_NUDGES" | "LISTING_PHOTO_IMPORT" | "LOCAL_KNOWLEDGE" | "NOISE_INSIGHT" | "PERSONA_JOURNEYS" | "REACHABLE_AREA_SCENE" | "REALTIME_PRESENCE" | "REAL_JOURNEY_TIMES" | "REMOTE_FETCH_IMPORT" | "VIEWINGS" | "VIEWING_NOTE_SUGGESTIONS" | "VOICE" | "%future added value";
export type FeatureKind = "EXPERIMENT" | "OPS" | "RELEASE" | "%future added value";
export type FeatureStage = "BETA" | "GA" | "INTERNAL" | "OFF" | "%future added value";
export type featureFlagMutationsSetPercentMutation$variables = {
  key: FeatureKey;
  percent: number;
};
export type featureFlagMutationsSetPercentMutation$data = {
  readonly setPercent: {
    readonly key: FeatureKey;
    readonly killed: boolean;
    readonly kind: FeatureKind;
    readonly percent: number;
    readonly stage: FeatureStage;
  };
};
export type featureFlagMutationsSetPercentMutation = {
  response: featureFlagMutationsSetPercentMutation$data;
  variables: featureFlagMutationsSetPercentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "percent"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      },
      {
        "kind": "Variable",
        "name": "percent",
        "variableName": "percent"
      }
    ],
    "concreteType": "FeatureFlagState",
    "kind": "LinkedField",
    "name": "setPercent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "killed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "featureFlagMutationsSetPercentMutation",
    "selections": (v1/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "featureFlagMutationsSetPercentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ad2a1c860451e33f5a8366a3a2cb847d",
    "id": null,
    "metadata": {},
    "name": "featureFlagMutationsSetPercentMutation",
    "operationKind": "mutation",
    "text": "mutation featureFlagMutationsSetPercentMutation(\n  $key: FeatureKey!\n  $percent: Int!\n) {\n  setPercent(key: $key, percent: $percent) {\n    key\n    stage\n    killed\n    percent\n    kind\n  }\n}\n"
  }
};
})();

(node as any).hash = "c08b8d835da6462ed1e638c751fdda5c";

export default node;
